
import Menu from '../Menu/Menú';
import Slider from '../Slider/Slider'

const Header = () => {    
    return <>
    <header className="position-relative">
        <Menu/>        
        <Slider/>
    </header>    
    </>
}
export default Header